import HttpService from 'src/lib/HttpService';

export default {
    async getFeatureFlags() {
        return await HttpService.proxiedApiCall({
            requestUrl: 'config/featureflags',
            type: 'get',
        });
    },
};